<template>
  <div class="jineng">
    <div class="title animate__animated wow animate__fadeInUp">
      <titleCard title="全国血液透析规范化大赛"></titleCard>
    </div>
    <div class="jianjie animate__animated wow animate__fadeInUp">
      <h4>活动简介</h4>
      <p class="p1">
        为更好的总结透析综合管理能力建设专项培训项目成果，挖掘基地教学资源，加强师资队伍建设，促进各基地经验<br />交流，完善教学模式，验证培训效果，国家卫生健康委能力建设和继续教育中心将依托透析专项培训基地，举办首<br />届“透析专项规范化操作技能竞赛”，以赛促学，进一步提升透析护士与临床技师的岗位胜任能力。
      </p>
      <p class="p2">
        为更好的总结透析综合管理能力建设专项培训项目成果，挖掘基地教学资源，加强师资队伍建设，促进各基地经验交流，完善教学模式，验证培训效果，国家卫生健康委能力建设和继续教育中心将依托透析专项培训基地，举办首届“透析专项规范化操作技能竞赛”，以赛促学，进一步提升透析护士与临床技师的岗位胜任能力。
      </p>
    </div>
    <div class="ruko"></div>
    <div class="details">
      <div class="title">
        首届“净护天使·透析专项规范化操作技能竞赛” <br />结果公示
      </div>
      <div class="box">
        <div class="head">护理组获奖名单</div>
        <div class="content">
          <div class="Hline">
            <div class="Sline">一等奖</div>
            <div class="Sline">薛小玲</div>
            <div class="Sline">郑州大学第一附属医院</div>
          </div>
          <div class="Hline">
            <div class="Sline">二等奖（2名）</div>
            <div class="Sline">
              张鹏月<br />
              张建平
            </div>
            <div class="Sline">
              北京大学人民医院<br />内蒙古医科大学附属医院
            </div>
          </div>
          <div class="Hline">
            <div class="Sline">三等奖（4名）</div>
            <div class="Sline">陈璠<br />吕小兵<br />黎敏<br />王琴</div>
            <div class="Sline">
              黄河三门峡医院<br />郑州大学第一附属医院<br />四川省人民医院<br />巴彦淖尔市医院<br />
            </div>
          </div>
        </div>
      </div>
      <div class="box jishi">
        <div class="head">技师组获奖名单</div>
        <div class="content">
          <div class="Hline">
            <div class="Sline">一等奖</div>
            <div class="Sline">孙锡宝</div>
            <div class="Sline">新疆维吾尔自治区人民医院</div>
          </div>
          <div class="Hline">
            <div class="Sline">二等奖</div>
            <div class="Sline">宋明阳</div>
            <div class="Sline">中国医学科学院北京协和医院</div>
          </div>
          <div class="Hline">
            <div class="Sline">三等奖</div>
            <div class="Sline">张成顺</div>
            <div class="Sline">新疆巴音郭楞蒙古自治州人民医院</div>
          </div>
        </div>
      </div>
      <div class="box zuijia">
        <div class="head">最佳团队奖名单</div>
        <div class="content">
          <h3 style="padding-top: 0.6rem">
            内蒙古科技大学包头医学院第一附属医院
          </h3>
          <h3>宁夏医科大学总医院</h3>
          <h3>内蒙古医科大学附属医院</h3>
          <h3>郑州大学第一附属医院</h3>
        </div>
      </div>
      <div class="btnbox">
        <div class="linkbtn">
          <span
            ><a
              href="http://www.gyycbj.com/jnds/index.html#/Home"
              target="_blank"
              >查看更多信息</a
            ></span
          >
        </div>
      </div>
    </div>
    <footerCard name="邹老师" phone="181-8084-6771"></footerCard>
  </div>
</template>

<script>
import titleCard from "../../components/title-card.vue";
import footerCard from "../../components/footer-card.vue";
export default {
  data() {
    return {};
  },
  created() {},
  components: {
    titleCard,
    footerCard,
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.jineng {
  .title {
    padding: 1rem 0;
  }
  .details {
    background: url("../../assets/image/Science/jineng/bgpc.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    @media screen and (max-width: 540px) {
      background-image: url("../../assets/image/Science/jineng/bgios.png");
    }
    .title {
      text-align: center;
      font-size: 32px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      padding: 160px 0 90px 0;
      line-height: 44px;
      @media screen and (max-width: 540px) {
        font-size: 16px;
        padding: 60px 0 40px 0;
        line-height: 22px;
      }
    }
    .jishi {
      background: linear-gradient(132deg, #f5f3ff 0%, #e7d5ff 100%) !important;
    }
    .zuijia {
      background: linear-gradient(132deg, #f3f7ff 0%, #dad5ff 100%) !important;
    }
    .box {
      background: linear-gradient(132deg, #fbf3ff 0%, #f1d5ff 100%);
      padding: 30px;
      width: 70%;
      margin: 0 auto;
      margin-bottom: 30px;
      @media screen and (max-width: 540px) {
        width: 86%;
        padding: 15px;
        margin-bottom: 15px;
      }
      .head {
        background: url("../../assets/image/Science/jineng/title.png") no-repeat;
        background-size: 100% 100%;
        width: 340px;
        height: 81px;
        line-height: 80px;
        margin: 0 auto;
        text-align: center;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        font-size: 28px;
        @media screen and (max-width: 540px) {
          width: 170px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }
      }
      .content {
        opacity: 0.72;
        background: #ffffff;
        border-radius: 16px;
        margin-top: 40px;
        @media screen and (max-width: 540px) {
          margin-top: 15px;
        }
        h3 {
          padding-bottom: 0.6rem;
          color: #000;
          font-size: 24px;
          margin: 0;
          text-align: center;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        .Hline {
          display: flex;
          border-bottom: 1px solid #d3bade;
          .Sline {
            padding: 0.8rem 0.3rem;
            line-height: 40px;
            text-align: left;
            color: #000;
            font-size: 24px;
            font-weight: 700;
            border-right: 1px solid #d3bade;
            @media screen and (max-width: 540px) {
              font-size: 14px;
            }
          }
          .Sline:nth-child(1) {
            width: 25%;
            @media screen and (max-width: 540px) {
              width: 32%;
            }
          }
          .Sline:nth-child(2) {
            width: 15%;
          }
          .Sline:last-child {
            width: 60%;
            border-right: none;
            @media screen and (max-width: 540px) {
              width: 53%;
            }
          }
        }
        .Hline:last-child {
          border-bottom: none;
        }
      }
    }
    .btnbox {
      .linkbtn {
        @media screen and (max-width: 540px) {
          height: 37px;
          line-height: 37px;
          width: 100%;
          background-size: 140% 100%;
          font-size: 12px;
          background-position: 52% 0;
        }
        width: 16.6316rem;
        height: 0.7895rem;
        line-height: 0.7895rem;
        background: url("../../assets/image/Science/zhuanxiang/zhuanxiang4.webp")
          no-repeat;
        background-size: 100% 100%;
        margin: 1.6842rem auto;
        text-align: center;
        a {
          cursor: pointer;
          font-size: 0.2947rem;
          color: #ffffff;
          span {
            cursor: pointer;
          }
        }
      }
    }
  }
  .jianjie {
    height: 3.8316rem;
    width: 100%;
    text-align: center;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/1E1A687F54B5401389BD689475654CF8-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 274px;
      background-size: cover;
    }
    h4 {
      color: #334046;
      font-size: 0.3368rem;
      padding: 0.5684rem 0;
      margin: 0;
      @media screen and (max-width: 540px) {
        font-size: 17px;
        padding: 36px 0 20px 0;
      }
    }
    p {
      color: #272b2d;
      font-size: 0.2526rem;
      line-height: 0.4211rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 26px;
        padding: 0 25px;
      }
    }
    .p1 {
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    .p2 {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
  }
  .ruko {
    width: 11.9368rem;
    height: 7.6421rem;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/0A9E876A697945CAB8B0B95BDE64F55A-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 1.1368rem;
    @media screen and (max-width: 540px) {
      margin: 0;
      width: 100%;
      height: 270px;
    }
  }
}
</style>
